import React from 'react'
import { ComponentWithElementProps } from '../types'

const Video = ({ element }: ComponentWithElementProps) => {
    return (
        <video src={`/download/${element.props.src}`} style={{ width: '100%', ...element.props, src: undefined }} controls />
    )
}

export default Video